jQuery(document).ready(function($) {
  // Event-Delegation für dynamisch hinzugefügte Elemente
  $(document).on('click', '.mehr-trigger', function(e) {
    e.preventDefault();
    var target = $(this).data('target');
    var $target = $(target);
    var $icon = $(this).find('.icon-plus');
    var $link = $(this);
    var textOpen = $link.data('text-open') || 'weniger lesen';
    var textClosed = $link.data('text-closed') || 'mehr lesen';
    var $card = $(this).closest('.component-card');
    var $row = $card.closest('.component-inner');
    var cardTop = $card.position().top;
    var $rowCards = $row.find('.component-card:visible').filter(function() {
      return $(this).position().top === cardTop;
    });

    if ($target.is(':visible')) {
      // SCHLIESSEN: erst Text ausblenden, dann Card-Höhe anpassen
      $target.fadeTo(200, 0, function() {
        $target.css('display', 'none');
        $icon.removeClass('is-open');
        $link.contents().filter(function() {
          return this.nodeType === 3;
        }).last().replaceWith(textClosed);
        $rowCards.css('height', 'auto');
        var maxHeight = 0;
        $rowCards.each(function() {
          maxHeight = Math.max(maxHeight, $(this).outerHeight());
        });
        $rowCards.css('height', maxHeight + 'px');
        if ($row.data('isotope')) {
          $row.isotope('layout');
        }
      });
    } else {
      // ÖFFNEN: erst Card-Höhe anpassen, dann Text einblenden
      $target.css({display: 'block', opacity: 0});
      // Höhe anpassen, damit Platz für den Text ist
      setTimeout(function() {
        $rowCards.css('height', 'auto');
        var maxHeight = 0;
        $rowCards.each(function() {
          maxHeight = Math.max(maxHeight, $(this).outerHeight());
        });
        $rowCards.css('height', maxHeight + 'px');
        if ($row.data('isotope')) {
          $row.isotope('layout');
        }
        // Dann Text einblenden
        $target.fadeTo(200, 1, function() {
          $icon.addClass('is-open');
          $link.contents().filter(function() {
            return this.nodeType === 3;
          }).last().replaceWith(textOpen);
        });
      }, 20);
    }
  });
});